import { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/Text';

export default function Step({
  children,
  status,
}: {
  children: ReactNode;
  status: 'open' | 'current' | 'done';
}) {
  return (
    <div
      className={`flex h-8 items-center rounded-lg border px-3 whitespace-nowrap ${
        status === 'current'
          ? 'bg-green/10 border-green'
          : 'transparent border-gray-30'
      } ${status === 'open' ? 'opacity-50' : ''}`}
    >
      <Text variant="studio/body/medium/sm">{children}</Text>
    </div>
  );
}
